import styles from './pwa.module.css';

export interface UpdateBannerProps {
  readonly needRefresh: boolean;
  readonly onUpdate: () => void;
}

/**
 * "Install/update does not strand stale assets" (`docs/implementation/06-mobile-web.md` 6.7).
 * A new build is already downloaded and waiting in the background; this is the owner's
 * explicit, visible way to pick it up, so a tab left open for days never keeps serving an old
 * bundle silently and never reloads underneath the owner's hands (mid-capture, mid-review)
 * without asking first.
 */
export function UpdateBanner({ needRefresh, onUpdate }: UpdateBannerProps) {
  if (!needRefresh) {
    return null;
  }

  return (
    <div className={styles.updateBanner} role="status">
      <span>Hay una nueva versión de NoteVision disponible.</span>
      <button type="button" className={styles.updateButton} onClick={onUpdate}>
        Actualizar ahora
      </button>
    </div>
  );
}
